module.exports = __webpack_public_path__ + "img/security.05b7f793.svg";